var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headers",style:(("background-image:url('" + _vm.baseUrl + "img/" + _vm.img + ".jpg')"))},[_c('div',{staticClass:"headerText"},[_vm._v(_vm._s(_vm.title.toUpperCase()))])])}
var staticRenderFns = []

export { render, staticRenderFns }